import React, { forwardRef } from 'react';
import { View } from '../../../../../components/Common/react-native-components';
import PieChartContainer from './PieChartContainer';
import EmojiMap from './EmojiMap';
import { Typography } from '@hmsexp/component-library';
import { userTranFormNetPromotorScore } from '../../../hooks/userTranFormNetPromotorScore';

const NetPromotorScore = forwardRef((props, ref) => {
  const { contentRef, onChartClick, isLowSampleSize, activeSwitch, pieChartTooptip, data } = props;

  const { options, npsDataObj } = userTranFormNetPromotorScore(data);


  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 20, alignItems: 'center', flex: 1 }}>
      <View>
        <PieChartContainer
          isLowSampleSize={isLowSampleSize}
          tooltipComponent={() => pieChartTooptip(options?.centerLabel.subLabel)}
          data={data}
          options={options}
          onChartClick={onChartClick}
          ref={ref}
          activeSwitch={activeSwitch}
        />
      </View>
      <View style={{ gap: 10 }}>
        <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
          <EmojiMap type='HAPPY' color='#88909F' backgroundColor='#F5F6F7' />
          <Typography variant='button' fontWeightType='regular'>
            {npsDataObj?.promoter_percentage}% ({npsDataObj?.promoter_count})
          </Typography>
        </View>
        <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
          <EmojiMap type='NEUTRAL' color='#88909F' backgroundColor='#F5F6F7' />
          <Typography variant='button' fontWeightType='regular'>
            {npsDataObj?.passive_percentage}% ({npsDataObj?.passive_count})
          </Typography>
        </View>
        <View style={{ flexDirection: 'row', gap: 10, alignItems: 'center' }}>
          <EmojiMap type='SAD' color='#88909F' backgroundColor='#F5F6F7' />
          <Typography variant='button' fontWeightType='regular'>
            {npsDataObj?.detractor_percentage}% ({npsDataObj?.detractor_count})
          </Typography>
        </View>
      </View>
    </View>
  );
});

export default NetPromotorScore;
